import * as React from 'react';

import { useDispatch } from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';
import { IAppPropsWithRoute } from '../../common/types';
import SignupWidget from './SignupWidget'
import { withRouter } from 'react-router-dom';

import backgroundPrimary from '../../assets/images/backgroundPrimary.png'
import { makeStyles, Theme } from '@material-ui/core/styles';

interface SignupPageProps extends IAppPropsWithRoute {
};

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        backgroundImage: `url(${backgroundPrimary})`,
        backgroundBlendMode: 'overlay',
        backgroundColor: 'rgba(0, 21, 46, 0.6)',
        height: '100%',
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        paddingTop: 80,
        paddingLeft: 40
    }
}));


//https://localhost:44364/signup/123
// where 123 is token for an invited user

function SignupPage(props: SignupPageProps): JSX.Element {
    const dispatch = useDispatch();
    const classes = useStyles();

    React.useEffect(() => {
        dispatch(showNavbar(false));
    }, [])

    const finishSignup = (isSuccess: boolean): void => {
        if (isSuccess) {
            props.history.push('/login');
        }
    }

    const inviteId = props.match.params.inviteId;

    return (
        <div className={classes.root}>
            <SignupWidget finishSignup={finishSignup} inviteId={inviteId}/>
        </div>
    );
}

export default React.memo(withRouter(SignupPage)) 
